import { IBannersResponseData } from '@/interfaces/banner.interfcae';
import axios from 'axios';

export const bannerService = {
  async getCurrentBannerProd() {
    const response = await axios.get<IBannersResponseData>(`https://fantasy-worlds.ru/api/admin_panel_router/baners/curent_baner`);
    return response;
  },
};
